import React, { useEffect, useState } from 'react';
import { Dropdown, List } from 'tea-component';
import { NewzooToDatabrain } from '@intelligence/utils/constant';
import { splitOldRouterPathNameList } from '../../../Metrics/component/IntelligenceMetrics';
import { getDataSourceIcon } from '@/pages/intelligence/utils/getDataSourceImg';

import appStore from '@/pages/intelligence/assets/svg/dataSource/appstore.svg';
import appannie from '@/pages/intelligence/assets/svg/dataSource/appannie.svg';
import googleplay from '@/pages/intelligence/assets/svg/dataSource/googleplay.svg';
import steam from '@/pages/intelligence/assets/svg/dataSource/steam.svg';
import twitch from '@/pages/intelligence/assets/svg/dataSource/twitch.svg';
import epic from '@/pages/intelligence/assets/svg/dataSource/epic.svg';
import mSci from '@/pages/intelligence/assets/svg/dataSource/mscience.svg';
import NPD from '@/pages/intelligence/assets/svg/dataSource/npd-icon.svg';
import Newzoo from '@/pages/intelligence/assets/svg/dataSource/databarin-gray.svg';
import sensorTower from '@/pages/intelligence/assets/svg/dataSource/sensor-tower.svg';
import hatchet from '@/pages/intelligence/assets/svg/dataSource/hatchet.svg';
import xbox from '@/pages/intelligence/assets/svg/dataSource/xbox.svg';
import nintendo from '@/pages/intelligence/assets/svg/dataSource/nintendo.svg';
import playstation from '@/pages/intelligence/assets/svg/dataSource/playstation.svg';
import famitsu from '@/pages/intelligence/assets/svg/dataSource/japanSales.svg';
import vg from '@/pages/intelligence/assets/svg/dataSource/vginsights.svg';
import steamcharts from '@/pages/intelligence/assets/svg/dataSource/steamcharts.svg';
import dataAI from '@/pages/intelligence/assets/svg/dataSource/app-annie.svg';
import defaultIcon from '@/pages/intelligence/assets/svg/dataSource/defaultSmall.svg';
import crunchbase from '@/pages/intelligence/assets/svg/dataSource/crunchbase.svg';
import taptap from '@/pages/intelligence/assets/svg/dataSource/taptap.svg';
import youtube from '@/pages/intelligence/assets/svg/dataSource/youtube.svg';
import steamdatabase from '@/pages/intelligence/assets/svg/dataSource/steamdatabase.svg';
import qimai from '@/pages/intelligence/assets/svg/dataSource/qimai.svg';
import facebook from '@/pages/intelligence/assets/svg/dataSource/facebook.svg';
import fbGaming from '@/pages/intelligence/assets/svg/dataSource/fbgaming-bg.svg';
import discord from '@/pages/intelligence/assets/svg/dataSource/discord.svg';
import xiaomi from '@/pages/intelligence/assets/svg/dataSource/xiaomi.svg';
import Instagram from '@/pages/intelligence/assets/svg/dataSource/instagram.svg';
import Metacritic from '@/pages/intelligence/assets/svg/dataSource/metacritic.svg';
import Cafe from '@/pages/intelligence/assets/svg/dataSource/cafe.svg';
import Opencritic from '@/pages/intelligence/assets/svg/dataSource/opencritic.svg';
import Reddit from '@/pages/intelligence/assets/svg/dataSource/reddit.svg';
import Ruliweb from '@/pages/intelligence/assets/svg/dataSource/ruliweb.svg';
import Tiktok from '@/pages/intelligence/assets/svg/dataSource/tiktok.svg';
import Twitter from '@/pages/intelligence/assets/svg/dataSource/twitter.svg';
import VK from '@/pages/intelligence/assets/svg/dataSource/vk.svg';
import YouTubeG from '@/pages/intelligence/assets/svg/dataSource/youtubegaming.svg';
import gsd from '@/pages/intelligence/assets/svg/dataSource/gsd-icon.svg';
import ampere from '@/pages/intelligence/assets/svg/dataSource/ampere.svg';
import gamalytic from '@intelligence/assets/svg/dataSource/gamalytic.svg';
import alinea from '@intelligence/assets/svg/dataSource/alinea.svg';

import './index.scss';

const channel = {
  'app annie': { img: appannie, name: 'data.ai' },
  'm science': { img: mSci, name: 'MScience' },
  npd: { img: NPD, name: 'NPD' },
  newzoo: { img: Newzoo, name: NewzooToDatabrain },
  'sensor tower': { img: sensorTower, name: 'Sensor Tower' },
  'stream hatchet': { img: hatchet, name: 'Stream Hatchet' },
  xbox: { img: xbox, name: 'Xbox' },
  nintendo: { img: nintendo, name: 'Nintendo' },
  'play station': { img: playstation, name: 'Play Station' },
  databrain: { img: Newzoo, name: 'DataBrain' },
  steamcharts: { img: steamcharts, name: 'SteamCharts' },
  'data.ai': { img: dataAI, name: 'data.ai' },
  crunchbase: { img: crunchbase, name: 'Crunchbase' },
  'steam database': { img: steamdatabase, name: 'Steam Database' },
  qimai: { img: qimai, name: 'Qimai' },
  famitsu: { img: famitsu, name: 'famitsu' },
  epgame: { img: epic, name: 'Epgame' },
  'epic games': { img: epic, name: 'EpicGames' },
  steam: { img: steam, name: 'Steam' },
  twitch: { img: twitch, name: 'Twitch' },
  twitter: { img: Twitter, name: 'Twitter' },
  twitch_keyword: { img: twitch, name: 'Twitch_Keyword' },
  vgtime: { img: vg, name: 'Vgtime' },
  'vg insights': { img: vg, name: 'Vgtime' },
  facebook: { img: facebook, name: 'Facebook' },
  facebook_gaming: { img: fbGaming, name: 'Facebook Gaming' },
  'facebook gaming': { img: fbGaming, name: 'Facebook Gaming' },
  reddit: { img: Reddit, name: 'Reddit' },
  metacritic: { img: Metacritic, name: 'Metacritic' },
  youtube_keyword: { img: youtube, name: 'youtube' },
  youtube: { img: youtube, name: 'Youtube' },
  ytg: { img: YouTubeG, name: 'Youtube' },
  youtube_gaming: { img: YouTubeG, name: 'Youtube gaming' },
  'youtube gaming': { img: YouTubeG, name: 'Youtube Gaming' },
  opencritic: { img: Opencritic, name: 'Opencritic' },
  'app store': { img: appStore, name: 'App Store' },
  'google play': { img: googleplay, name: 'Google Play' },
  tiktok: { img: Tiktok, name: 'Tiktok' },
  vk: { img: VK, name: 'Vk' },
  cafe: { img: Cafe, name: 'Cafe' },
  'naver cafe': { img: Cafe, name: 'Naver Cafe' },
  navercafe: { img: Cafe, name: 'Naver Cafe' },
  navergame: { img: Cafe, name: 'Naver Game' },
  instagram: { img: Instagram, name: 'Instagram' },
  discord: { img: discord, name: 'Discord' },
  taptap: { img: taptap, name: 'taptap' },
  kwai: { img: defaultIcon, name: 'kwai' },
  ruliweb: { img: Ruliweb, name: 'Ruliweb' },
  mi: { img: xiaomi, name: 'Xiaomi Market' },
  七麦数据: { img: qimai, name: '七麦数据' },
  taptap国际版: { img: taptap, name: 'Taptap国际版' },
  小米应用商店: { img: xiaomi, name: '小米应用商店' },
  googleplay: { img: googleplay, name: 'GooglePlay' },
  epic: { img: epic, name: 'Epic' },
  playstation: { img: playstation, name: 'PlayStation' },
  mscience: { img: mSci, name: 'MScience' },
  vginsights: { img: vg, name: 'vginsights' },
  'sparkers(gsd)': { img: gsd, name: 'Sparkers(GSD)' },
  'other vendor': { img: ampere, name: 'Other Vendor' },
  gamalytic: { img: gamalytic, name: 'Gamalytic' },
  alinea: { img: alinea, name: 'Alinea Analytics' },
};

export type ChannelIconType = keyof typeof channel;

export function channelInfo(channel_name: ChannelIconType) {
  const channelConfig = channel[channel_name];
  if (channelConfig) {
    return channelConfig;
  }
  return {
    img: defaultIcon,
    name: channel_name,
  };
}

/** 仅解析 data_source：https 远程图 / icon key；未命中返回 undefined，走 channelInfo 兜底 */
export function getDataSourceIconSrc(dataSource?: string): string | undefined {
  if (typeof dataSource !== 'string') {
    return undefined;
  }
  const trimmed = dataSource.trim();
  if (!trimmed) {
    return undefined;
  }
  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }
  const channelKey = trimmed.toLowerCase() as ChannelIconType;
  if (channelKey in channel) {
    return channel[channelKey].img;
  }
  return getDataSourceIcon(trimmed) || undefined;
}

export const imgInvert = ['Steam', 'Tiktok', 'Play Station', 'Epic Games', 'Steam Database'];
export const imgInvertChartBubble = [
  'pcu',
  'steam new and trending',
  'steamfollowers',
  'steam top wish lists',
  'playstation new games',
  'playstation coming soon',
];

export default function ChannelLabel({
  channel_name,
  showText = true,
  style = {},
  iconStyle = {},
  iconUrl,
  replaceText,
  typeDetails,
  record,
  onClickLink,
}: {
  channel_name: ChannelIconType;
  showText?: boolean;
  style?: React.CSSProperties;
  iconStyle?: React.CSSProperties;
  iconUrl?: string;
  replaceText?: string;
  typeDetails?: any;
  record: { [key in string]: unknown };
  onClickLink?: (...args: any[]) => void;
}) {
  const channel = channelInfo(channel_name);
  const { img: fallbackImg } = channel;
  const { name } = channel;
  const [imgSrc, setImgSrc] = useState(iconUrl || fallbackImg);

  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    setImgSrc(iconUrl || fallbackImg);
  }, [iconUrl, fallbackImg]);

  return (
    <div
      className={`${onClickLink ? 'dbi-channel-label-point' : ''} dbi-channel-label`}
      style={style}
    >
      <img
        style={iconStyle}
        src={imgSrc}
        onError={() => {
          if (imgSrc !== fallbackImg) {
            setImgSrc(fallbackImg);
          }
        }}
        className={`dbi-sm-channellabel-icon ${
          imgInvert.includes(replaceText || name) ? 'db-invert-unset' : ''
        }`}
      />
      {typeDetails ? (
        <Dropdown
          open={isOpen}
          className={`${isOpen ? 'dbi-channel-label-action' : ''} dbi-channel-label-dropdown`}
          trigger="click"
          button={replaceText ? replaceText : name}
          onOpen={() => setOpen(true)}
          onClose={() => setOpen(false)}
        >
          <List type="option">
            {typeDetails.map((e: any, i: any) => (
              <List.Item
                key={e.id}
                onClick={() => {
                  setOpen(false);
                  onClickLink?.(e);
                }}
              >
                {e.text}
              </List.Item>
            ))}
          </List>
        </Dropdown>
      ) : (
        showText && (
          <span
            className="dbi-sm-channellabel-label"
            onClick={() => onClickLink?.({ url: splitOldRouterPathNameList(record.url) })}
          >
            {replaceText ? replaceText : name}
          </span>
        )
      )}
    </div>
  );
}

/**
 * 获取渠道的legendRich对象
 * @param width   显示的宽度
 * @param height  显示的高度
 * @returns
 */
export function channelLegendRichInfo(width: number, height: number) {
  const obj: { [key in ChannelIconType]?: any } = {};
  for (const key in channel) {
    const newKey = key as ChannelIconType;
    const element = channel[newKey];
    obj[newKey] = {
      height,
      width,
      backgroundColor: {
        image: element.img,
      },
    };
  }
  return obj;
}
